module.exports = __webpack_public_path__ + "static/img/posco-safety-consulting.5b5e993.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/posco-safety-consulting.jpg
// module id = Zp6F
// module chunks = 0